import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coachtraining-department',
  templateUrl: './coachtraining-department.component.html',
  styleUrls: ['./coachtraining-department.component.scss']
})
export class CoachtrainingDepartmentComponent implements OnInit {
  /**
   * Definição da identificão da sessão/depto Capacitação
   */
  public departmentId: string = '26';

  constructor() { }

  ngOnInit(): void {
  }

}
